// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.name {
  font-weight: 600;
}

.card {
  width: 100%;
  padding: 15px 15px 0px 15px;
  margin-top: 10px;
}
.card .cardTitle {
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
}

.table-header {
  border-bottom: 2px solid var(--color-primary);
  font-style: normal;
  font-size: 14px;
}

.table thead th {
  font-weight: 400;
}

.header-title {
  color: var(--color-interaction-text);
}

.table-content {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
}

.error {
  margin: 20px 0px 0px 0px;
}

.next-btn:focus-within {
  outline: black solid 2px;
  outline-offset: 0px;
}

.table {
  table-layout: fixed;
}

.sub-content {
  padding: 10px 0px 15px 0px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
}

.checklistBorder {
  display: block;
  padding-bottom: 10px;
  border-bottom: 2px solid var(--color-primary);
}

.checkboxAlignment {
  font-style: normal;
  font-weight: 600;
  padding-left: 15px;
}

.headerFont {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
}

.m-screen-header-wrapper {
  position: relative;
  z-index: 100;
}`, "",{"version":3,"sources":["webpack://./ClientApp/src/app/desktop/d-landing-page/confirm-return/confirm-return.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AACA;EACE,WAAA;EACA,2BAAA;EACA,gBAAA;AAEF;AADE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;AAGJ;;AAAA;EACE,6CAAA;EACA,kBAAA;EACA,eAAA;AAGF;;AADA;EACE,gBAAA;AAIF;;AAFA;EACE,oCAAA;AAKF;;AAHA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAMF;;AAJA;EACE,wBAAA;AAOF;;AALA;EACE,wBAAA;EACA,mBAAA;AAQF;;AALA;EACE,mBAAA;AAQF;;AANA;EACE,0BAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AASF;;AAPA;EACE,cAAA;EACA,oBAAA;EACA,6CAAA;AAUF;;AARA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;AAWF;;AATA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;AAYF;;AATA;EACE,kBAAA;EACA,YAAA;AAYF","sourcesContent":[".name {\n  font-weight: 600;\n}\n.card {\n  width: 100%;\n  padding: 15px 15px 0px 15px;\n  margin-top: 10px;\n  .cardTitle {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 18px;\n  }\n}\n.table-header {\n  border-bottom: 2px solid var(--color-primary);\n  font-style: normal;\n  font-size: 14px;\n}\n.table thead th {\n  font-weight: 400;\n}\n.header-title {\n  color: var(--color-interaction-text);\n}\n.table-content {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16px;\n}\n.error {\n  margin: 20px 0px 0px 0px;\n}\n.next-btn:focus-within {\n  outline: black solid 2px;\n  outline-offset: 0px;\n}\n\n.table {\n  table-layout: fixed;\n}\n.sub-content {\n  padding: 10px 0px 15px 0px;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n}\n.checklistBorder {\n  display: block;\n  padding-bottom: 10px;\n  border-bottom: 2px solid var(--color-primary);\n}\n.checkboxAlignment {\n  font-style: normal;\n  font-weight: 600;\n  padding-left: 15px;\n}\n.headerFont {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.m-screen-header-wrapper {\n  position: relative;\n  z-index: 100;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
